import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { dateTypeFormat } from "@/assets/js/common";
import eventBus from "@/assets/js/eventBus.js"; // 引入封装的方法
import "@wangeditor/editor/dist/css/style.css";
import "@/assets/css/iconfont/iconfont.css";
Vue.use(ElementUI);
Vue.prototype.$dateTypeFormat = dateTypeFormat;
Vue.prototype.$bus = eventBus;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
